export {
  default,
  months,
  lang,
  getLanguage,
  getLocale,
  hasTranslation,
} from "./Translate.js";
